import { PsychosocialReportService } from '@/infra/services/psychosocial-report';
import { QUERY_KEYS } from '@/utils/query-keys';
import { useQuery } from '@tanstack/react-query';

export interface GetParticipationsByEmployeeParams {
	employee_id: string;
}

const Service = PsychosocialReportService.getInstance();

export const useGetParticipationsByEmployee = (params: GetParticipationsByEmployeeParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_PARTICIPATIONS_BY_EMPLOYEE, params],
		queryFn: async () => Service.getParticipationsByEmployee(params),
		enabled: !!params.employee_id
	});
};
